import { Routes } from '@angular/router';

export const LayoutRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./landing/landing').then(m => m.Landing)
    },
    {
        path: 'features',
        loadComponent: () => import('./features/features').then(m => m.Features)
    },
    {
        path: 'contact',
        loadComponent: () => import('./contact/contact').then(m => m.Contact)
    },
    {
        path: 'pricing',
        loadComponent: () => import('./pricing/pricing').then(m => m.Pricing)
    },
    {
        path: 'terms',
        loadComponent: () => import('./terms/terms').then(m => m.Terms)
    },
    {
        path: 'privacy',
        loadComponent: () => import('./privacy/privacy').then(m => m.Privacy)
    },
];